import { debug as debugGen } from "debug";
import { ActionItem } from "../../types";
import { ENUM_USER_ACTION_REPORT_TYPE } from "../../actionTypes";
import Compose from "../Compose";

const debug = debugGen("vtTracker:CustomCompose");

interface EventData {
    actionId: number;
    actionValue?: number;
    reportType?: number;
    busiInfo?: {
        [K: string]: string;
    };
}

export default class Custom extends Compose {
    compose(): ActionItem {
        const { level, page, item } = this.extraActionItem();

        debug(
            "stay compose level [%d], page [%o], item [%o]",
            level,
            page,
            item
        );

        const data = this.event["data"] as EventData;

        if (typeof data === "undefined" || !data.actionId) {
            return null;
        }

        item.action_id = data.actionId;

        item.action_value = data.actionValue || 0;

        if (data.reportType) {
            item.reportType = data.reportType as ENUM_USER_ACTION_REPORT_TYPE;
        }

        if (data.busiInfo) {
            if (item.busi_info) {
                try {
                    const info = JSON.parse(item.busi_info);

                    item.busi_info = JSON.stringify({
                        ...info,
                        ...data.busiInfo
                    });
                } catch (err) {
                    debug("merge busi info from custom event error: %o", err);

                    item.busi_info = JSON.stringify(data.busiInfo);
                }
            } else {
                item.busi_info = JSON.stringify(data.busiInfo);
            }
        }

        return item;
    }
}
